import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/coast-fire-calculator',
  component: () => import('../../routes/CoastFireCalculator.svelte'),
  card: {
    id: 'coast-fire-calculator',
    title: 'Coast FIRE Calculator',
    description: 'Find the savings threshold where you can stop contributing and still reach retirement on compound growth alone.',
    icon: 'sailing',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/coast-fire-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Coast FIRE Calculator – Find Your Coast Number & Stop Contributing Early',
    description: 'Free Coast FIRE calculator to find the savings amount where you can stop contributing and still reach retirement. Calculate your Coast Number, Coast FI progress, and years until financial independence.',
  },
};

export default meta;
